import { usePremiumAccess } from '@hellodarwin/app-core/lib/providers/premium-access-provider';
import Modal from '@hellodarwin/core/lib/components/common/hd-modal';
import PlanTile from '@hellodarwin/core/lib/components/plan-tile';
import {
  PlanDuration,
  PlanType,
} from '@hellodarwin/core/lib/features/entities/checkout-entities';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import React, { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../app/app-hooks';
import {
  fetchContentfulPlans,
  selectContentfulPlans,
} from '../../../../../features/api/slices/checkout-slice';
import {
  closeLockedFeatureModal,
  selectLockedFeatureModal,
} from '../../../../../features/api/slices/global-slice';
import { useCreateHandleCheckout } from '../../../../../hooks/use-create-handle-checkout';
import { LockedFeatureModalContainer } from './styles';

const LockedFeatureModal: React.FC = () => {
  const { selectedLocale } = useLocale();
  const { contentfulClient } = usePlatform();
  const { accessLevel } = usePremiumAccess();
  const dispatch = useAppDispatch();
  const contentfulPlans = useAppSelector(selectContentfulPlans);
  const lockedFeatureModal = useAppSelector(selectLockedFeatureModal);
  const handleCheckout = useCreateHandleCheckout();

  const handleClose = useCallback(() => {
    dispatch(closeLockedFeatureModal());
  }, [dispatch]);

  useEffect(() => {
    if (contentfulClient && lockedFeatureModal.isOpen) {
      dispatch(
        fetchContentfulPlans({ contentfulClient, locale: selectedLocale }),
      );
    }
  }, [contentfulClient, selectedLocale, lockedFeatureModal.isOpen, dispatch]);

  const handlePlanSelection = useCallback(
    (planType: PlanType, duration: PlanDuration) => {
      handleCheckout(duration);
      handleClose();
    },
    [handleCheckout, handleClose],
  );

  return (
    <Modal
      open={lockedFeatureModal.isOpen}
      handleCancel={handleClose}
      footer={null}
      size="medium"
    >
      <LockedFeatureModalContainer>
        <PlanTile
          {...contentfulPlans['premium']}
          tileType="standard"
          handleClick={handlePlanSelection}
          isCurrentPlan={
            accessLevel === 'premium' || accessLevel === 'expert'
          }
        />
      </LockedFeatureModalContainer>
    </Modal>
  );
};

export default LockedFeatureModal;
